module.exports = __webpack_public_path__ + "media/images/button_card-13e2cd42590bc81915eaa57fcdf9eef5.svg";